import Layout from "../../internal/Layout.vue";
import DetailCourses from "./DetailCourses.vue";
import Courses from "./Courses.vue";
import Category from "./Category.vue";
import CheckoutCourse from "./Checkout/CheckoutCourse.vue";
import StatusCheckoutCourse from "./Checkout/StatusCheckoutCourse.vue";
import Combos from "./Combos.vue";
import CheckoutCombo from "./Checkout/CheckoutCombo.vue";
import StatusCheckoutCombo from "./Checkout/StatusCheckoutCombo.vue";

const CoursesRoutes = {
    component: Layout,
    children: [
        {
            path: "/cursos",
            name: "Courses",
            component: Courses,
            meta: {},
        },
        {
            path: "/cursos/:name",
            name: "DetailCourses",
            component: DetailCourses,
            meta: {},
        },
        {
            path: "/cursos/categoria/:category",
            name: "Category",
            component: Category,
            meta: {},
        },
        {
            path: "/cursos/checkout/:courseLinkSearch/:courseGroupId",
            name: "CheckoutCourse",
            component: CheckoutCourse,
            meta: {},
        },
        {
            path: "/cursos/checkout/status/:courseLinkSearch/:courseGroupId/:orderCourseGroupId",
            name: "StatusCheckoutCourse",
            component: StatusCheckoutCourse,
            meta: {},
        },
        {
            path: "/cursos/combos/lista",
            name: "Combos",
            component: Combos,
            meta: {},
        },
        {
            path: "/cursos/combos/checkout/:comboId",
            name: "CheckoutCombo",
            component: CheckoutCombo,
            meta: {},
        },
        {
            path: "/cursos/combos/checkout/status/:comboId",
            name: "StatusCheckoutCombo",
            component: StatusCheckoutCombo,
            meta: {},
        },
    ],
};

export default CoursesRoutes;
